import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AuthView from './components/AuthView';
import { TextIconInputField } from '../../components/UI/TextInputField';
import { IdCard, User2 } from 'lucide-react';
import BackToLoginBtn from './components/BackToLoginBtn';
import PrimaryButton from '../../components/UI/PrimaryButton';
import { MediumText, SubtitleText } from '../../components/UI/Typography/PageHeader';
import { useRegistrationHooks } from './hooks/useLoginHooks';
import Visibility from '../../components/UI/Containers/Visibility';
import CircularProgress from '@material-ui/core/CircularProgress';
import Column from '../../components/UI/Containers/Column';
import LoadingIcon from '../../components/UI/LoadingIcon';
import { useHistory } from 'react-router';

const SignUpView = () => {
  const { t } = useTranslation();
  const { nationalId, setNationalId, randomNumber, signUpMutation, onSignUpClick } =
    useRegistrationHooks();

  const history = useHistory();

  useEffect(() => {
    history.replace('/auth/login');
  }, [history]);

  return (
    <AuthView
      title={t('auth.create_account')}
      subtitle={t('auth.create_account_nid')}
    >
      <section className="w-full col items-center justify-center gap-5">
        {/* Email Field */}
        <Visibility
          isVisible={randomNumber === null}
          replacement={
            <Column className="items-center gap-5">
              <div className="w-16 h-16 rounded-full border bg-primary centerDiv text-white font-bold text-lg">
                {randomNumber}
              </div>

              <SubtitleText text={t('auth.nafath_number')} />
            </Column>
          }
        >
          <TextIconInputField
            type="email"
            isFullWidth
            labelClassName="font-semibold"
            label={t('auth.national_id')}
            placeholder={t('enter_national_id')}
            startIcon={<IdCard size={18} className="text-lightGrayText" />}
            //
            value={nationalId}
            onValueChange={(v) =>
              setNationalId(v.replace(/[^0-9]/g, '').slice(0, 10))
            }
          />
        </Visibility>

        {/* Verify OTP Button */}
        <Visibility
          isVisible={randomNumber === null}
          replacement={<LoadingIcon size="medium" />}
        >
          <PrimaryButton
            isLoading={signUpMutation.isLoading}
            isDisabled={nationalId.length !== 10}
            isFullWidth
            title={t('components.confirmation_dialog.continue')}
            onClick={onSignUpClick}
          />
        </Visibility>

        {/* Back to Login Button */}
        <BackToLoginBtn title={t('common.go_back')} />
        <SubtitleText text={t('auth.registration_help')}>
          <a
            className="text-secondary font-semibold"
            target="__blank"
            href={'https://www.youtube.com/watch?v=d2rX5o4EPeE'}
          >
            {t('auth.click_here')}
          </a>
        </SubtitleText>
      </section>
    </AuthView>
  );
};

export default SignUpView;
